<template>
  <v-row no-gutters class="fill-height">
    <crud-factory
      :serviceName="serviceName"
      :customFunctions="customFunctions"
      :crudDialog="crudDialog"
    />
  </v-row>
</template>

<script>
import PlanificacioService from "../../services/PlanificacioService"

export default {
  components: {
    crudFactory: () => import("./CrudFactory"),
  },
  data() {
    return {
      serviceName: "planificacions",
      customFunctions: {
        downloadPdf(id) {
          PlanificacioService.getPdf(id).then(response => {
            const link = document.createElement("a")
            link.href =
              "data:application/octet-stream;base64," + response.data.binary
            link.download = response.data.filename + ".pdf"
            link.dispatchEvent(new MouseEvent("click"))
          })
        },
      },
      crudDialog: {
        large: false,
        createTitle: "Nova planificació",
        modelKeyTitle: "nom",
      },
    }
  },
}
</script>

<style lang="scss" scoped />
